import React from "react";
import { Constants } from "../CommonMethods/Constants";

function FormFooterPartner(props) {
  const sendOtpResp = props.sendOtpResp;
  return (
    <div className="form-bottom-wrapper">
      {/* <p className="title-text">BAJAJ BROKING</p> */}
      <p className="copyright part-copyright">SEBI Registration No.: INZ000218931 | BSE Cash/CDS/F&O (Member ID: 6706) | NSE Cash/F&O/CDS (Member ID: 90177) | DP registration No : IN-DP-418-2019 | CDSL DP No.: 12088600 | NSDL DP No. IN304300 | AMFI Registration No.: ARN – 163403 Research Analyst SEBI Registration No. INH000010043</p>
    </div>
  );
}

export default FormFooterPartner;
